module.exports = __webpack_public_path__ + "assets/f32df518d91e1f50c6f66d09eaf71e0a.mp4";